// ===========================================
// NOTIFICATIONS SERVICE - In-App + External
// ===========================================

import api from './api';

export interface InAppNotification {
  id: string;
  title: string;
  body: string;
  type: string;
  data?: Record<string, any>;
  readAt?: string | null;
  createdAt: string;
}

export interface NotificationsListResponse {
  notifications: InAppNotification[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const notificationsService = {
  // In-app notifications
  async listInApp(params: { status?: 'unread' | 'all'; page?: number; limit?: number } = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) query.append(key, String(value));
    });
    return api.get<NotificationsListResponse>(`/api/notifications/in-app?${query.toString()}`);
  },

  async createInApp(data: { title: string; body: string; type?: string; userId?: string; data?: Record<string, any> }) {
    return api.post<{ notification: InAppNotification }>(`/api/notifications/in-app`, data);
  },

  async markRead(id: string) {
    return api.patch<{ notification: InAppNotification }>(`/api/notifications/in-app/${id}/read`);
  },

  async markAllRead() {
    return api.post<{ updated: number }>(`/api/notifications/in-app/mark-all-read`);
  },

  // External senders
  async sendEmail(data: { to: string | string[]; subject: string; html: string; text?: string; replyTo?: string }) {
    return api.post(`/api/notifications/email/send`, data);
  },

  async sendSMS(data: { to: string; body: string }) {
    return api.post(`/api/notifications/sms/send`, data);
  },

  async sendWhatsApp(data: { to: string; body: string; mediaUrl?: string[]; templateSid?: string; templateVariables?: Record<string, string> }) {
    return api.post(`/api/notifications/whatsapp/send`, data);
  },

  // Service status & tests
  async getStatus() {
    return api.get(`/api/notifications/status`);
  },

  async testEmail(to?: string) {
    return api.post(`/api/notifications/test/email`, { to });
  },

  async testSMS(to: string) {
    return api.post(`/api/notifications/test/sms`, { to });
  },

  async testStatus() {
    return api.get(`/api/notifications/test/status`);
  },
};

export default notificationsService;
